export default {
  "auth.loginTitle": "Log in",
  "auth.loginSubtitle": "Welcome back to BajApp Xperiences",
  "auth.registerTitle": "Create account",
  "auth.registerSubtitle": "Join the BajApp Xperiences community",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.confirmPassword": "Confirm password",
  "auth.fullName": "Full name",
  "auth.phone": "Phone",
  "auth.forgotPassword": "Forgot your password?",
  "auth.rememberMe": "Remember me",
  "auth.loginBtn": "Log in",
  "auth.registerBtn": "Sign up",
  "auth.noAccount": "Don't have an account?",
  "auth.hasAccount": "Already have an account?",
  "auth.signUp": "Sign up",
  "auth.signIn": "Log in",
  "auth.or": "or",
  "auth.google": "Continue with Google",
  "auth.facebook": "Continue with Facebook",
  "auth.chooseRoleTitle": "Create account",
  "auth.chooseRoleSubtitle": "How do you want to join BajApp Xperiences?",
  "auth.travelerCardTitle": "I'm a traveler",
  "auth.travelerCardDesc": "Book tours, experiences, transport and accommodation in Baja California Sur.",
  "auth.continueAsTraveler": "Continue as traveler",
  "auth.providerCardTitle": "I'm a provider",
  "auth.providerCardDesc": "List your tours, vehicles, or properties and start receiving bookings.",
  "auth.continueAsProvider": "Continue as provider",
  "auth.registerClientTitle": "Sign up as traveler",
  "auth.registerClientSubtitle": "Create your traveler account",
  "auth.registerProviderTitle": "Sign up as provider",
  "auth.registerProviderSubtitle": "Create your provider account",
  "auth.verifyingEmail": "Check your email",
  "auth.checkInbox": "We sent you a verification link. Please check your inbox.",
  "auth.forgotTitle": "Forgot your password?",
  "auth.forgotSubtitle": "Enter your email and we'll send you a reset link.",
  "auth.forgotSentTitle": "Email sent",
  "auth.forgotSentDesc": "If an account exists with that email, you'll receive a reset link shortly.",
  "auth.backToLogin": "Back to login",
  "auth.sendResetLink": "Send reset link",
  "auth.resetTitle": "Reset password",
  "auth.resetSubtitle": "Enter your new password below.",
  "auth.newPassword": "New password",
  "auth.resetBtn": "Reset password",
  "auth.resetSuccessTitle": "Password updated",
  "auth.resetSuccessDesc": "Your password has been changed successfully. You can now log in.",
  "auth.verifyVerifyingTitle": "Verifying email...",
  "auth.verifyVerifyingDesc": "Please wait while we verify your email address.",
  "auth.verifySuccessTitle": "Email verified",
  "auth.verifySuccessDesc": "Your email has been verified successfully. You can now log in to your account.",
  "auth.verifyErrorTitle": "Verification failed",
  "auth.verifyErrorDesc": "The verification link is invalid or has expired. Please try again.",
  "auth.resendEmail": "Resend email",
  "auth.registerAgain": "Register again",
  "auth.providerCompany": "Business name",
  "auth.providerRfc": "Tax ID (optional)",
  "auth.providerLocation": "Business location",
  "auth.providerDesc": "What services do you offer?",
  "auth.terms": "By signing up you agree to our terms and privacy policy",
  "auth.acceptsMarketing": "I want to receive offers, promotions and news by email. You can unsubscribe at any time.",
  "auth.required": "Required field",
  "auth.invalidEmail": "Invalid email",
  "auth.showPassword": "Show password",
  "auth.hidePassword": "Hide password",
  "auth.passwordMin": "Minimum 8 characters",
  "auth.passwordMatch": "Passwords do not match",
  "auth.errEmailTaken": "This email is already registered",
  "auth.errInvalidCreds": "Incorrect email or password",
  "auth.errGeneric": "Something went wrong. Please try again.",
  "auth.submitting": "Processing...",
  "auth.clientTab": "I'm a traveler",
  "auth.providerTab": "I'm a provider",
  "auth.unknownError": "An unexpected error occurred.",
  "auth.resetTokenMissing": "The token is missing from the link.",
  "auth.goToAccount": "Go to my account",
  "auth.comingSoon": "Coming soon",
  "auth.loadingGoogle": "Loading Google…",
  "auth.googleNotConfigured": "Google sign-in is not configured (VITE_GOOGLE_CLIENT_ID)",
  "auth.googleLoadError": "Couldn't load Google.",
};